export const roles = {
  ADMIN: "ADMIN",
  DOCTOR: "DOCTOR",
  RECEPCIONISTA: "RECEPCIONISTA",
  LABORATORIO: "LABORATORIO",
};
export const TITLE = "CONSULTORIO DENTAL";
export const TOKEN_NAME = "SUPERADMIN_TOKEN";
